<template>
  <div class="w-full">
    <PageHeader title="Promotion limitée" />

    <div class="w-full px-6 py-6">
      <!-- Section des filtres -->
      <div class="bg-white rounded-lg border border-gray-200 shadow-sm px-3 py-2 mb-6">
        <h2 class="text-xs font-semibold text-gray-800 mb-2 flex items-center gap-2">
          <i class="fas fa-filter text-blue-600 text-sm"></i>
          Filtrer la liste par
        </h2>

        <form @submit.prevent>
          <div
              class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-x-4 gap-y-2"
          >
            <!-- Référence -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Référence
              </label>
              <input
                  v-model.trim="filters.reference"
                  type="text"
                  placeholder="Rechercher par référence"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
           focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
           bg-white"
              />
            </div>

            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Marque
              </label>
              <select
                  v-model="filters.brand"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
           focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
           bg-white"
              >
                <option value="">---</option>
                <option
                  v-for="b in brandOptions"
                  :key="b.number"
                  :value="b.name"
                >
                  {{ b.name }}
                </option>
              </select>
            </div>

            <!-- Vendu par -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Vendu par
              </label>
              <select
                  v-model="filters.soldBy"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                 bg-white"
              >
                <option value="">-- Vendu par --</option>
                <option
                  v-for="vp in soldByOptions"
                  :key="vp || 'vide'"
                  :value="vp"
                >
                  {{ vp || '—' }}
                </option>
              </select>
            </div>

            <!-- Nombre de produits / page -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Nombre de produits / page
              </label>
              <select
                  v-model="filters.productsPerPage"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                 bg-white"
              >
                <option value="">-- Nombre de produits --</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            <!-- Afficher par -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Afficher par
              </label>
              <select
                  v-model="filters.displayBy"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                 bg-white"
              >
                <option value="">-- Afficher par --</option>
                <option value="date">Date</option>
                <option value="nom">Nom</option>
                <option value="prix">Prix</option>
              </select>
            </div>

            <!-- Trier par -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Trier par
              </label>
              <select
                  v-model="filters.sortBy"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                 bg-white"
              >
                <option value="">-- Trier par --</option>
                <option value="asc">Croissant</option>
                <option value="desc">Décroissant</option>
              </select>
            </div>

            <!-- Catégorie -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Catégorie
              </label>
              <select
                  v-model.number="filters.category"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                 bg-white"
              >
                <option value="">-- Choisir une catégorie --</option>
                <option
                  v-for="cat in level1Categories"
                  :key="cat.id_categorie"
                  :value="cat.id_categorie"
                >
                  {{ cat.label }}
                </option>
              </select>
            </div>

            <!-- Sous-catégorie -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Sous-catégorie
              </label>
              <select
                  v-model.number="filters.subCategory"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                 bg-white"
              >
                <option value="">-- Choisir une sous-catégorie --</option>
                <option
                  v-for="cat in level2Categories"
                  :key="cat.id_categorie"
                  :value="cat.id_categorie"
                >
                  {{ cat.label }}
                </option>
              </select>
            </div>

            <!-- SS-catégorie -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                SS-catégorie
              </label>
              <select
                  v-model.number="filters.subSubCategory"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                 bg-white"
              >
                <option value="">-- Choisir une ss-catégorie --</option>
                <option
                  v-for="cat in level3Categories"
                  :key="cat.id_categorie"
                  :value="cat.id_categorie"
                >
                  {{ cat.label }}
                </option>
              </select>
            </div>

            <!-- Période de création - début -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Début de création
              </label>
              <input
                  v-model="filters.creationPeriodStart"
                  type="date"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              />
            </div>

            <!-- Période de création - fin -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                Fin de création
              </label>
              <input
                  v-model="filters.creationPeriodEnd"
                  type="date"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              />
            </div>

            <!-- ID shooting -->
            <div class="w-full">
              <label class="block text-xs font-medium text-gray-700 mb-1">
                ID shooting
              </label>
              <input
                  v-model.trim="filters.shootingId"
                  type="text"
                  placeholder="ID Shooting"
                  class="w-full h-9 px-3 text-sm border border-gray-300 rounded-md
                 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              />
            </div>
          </div>

          <!-- Boutons d'action -->
          <div class="flex justify-end gap-2 mt-3">
            <button
                type="button"
                @click="applyFilters"
                class="inline-flex items-center justify-center
               px-3 py-1.5 text-xs font-medium rounded-md
               bg-blue-600 text-white hover:bg-blue-700
               transition-colors"
            >
              <i class="fas fa-search mr-1"></i>
              Filtrer
            </button>

            <button
                type="button"
                @click="exportToExcel"
                class="inline-flex items-center justify-center
               px-3 py-1.5 text-xs font-medium rounded-md
               bg-green-600 text-white hover:bg-green-700
               transition-colors"
            >
              <i class="fas fa-download mr-1"></i>
              Exporter en Excel
            </button>
          </div>
        </form>
      </div>


      <!-- Liste des campagnes -->
      <div v-if="campagnes.length > 0" class="bg-white rounded-xl shadow-lg border border-gray-200 p-6 mb-6">
        <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <i class="fas fa-tags text-blue-600"></i>
          Liste des campagnes de promotion limitée
        </h3>
        
        <!-- Onglets des campagnes -->
        <ul class="nav nav-tabs border-b border-gray-200 mb-4">
          <li 
            v-for="campagne in campagnes" 
            :key="campagne.id_campagne"
            class="inline-block mr-2"
          >
            <button
              @click="selectedCampagneId = campagne.id_campagne"
              :class="[
                'px-4 py-2 rounded-t-lg transition-colors',
                selectedCampagneId === campagne.id_campagne
                  ? 'bg-blue-600 text-white font-semibold'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              ]"
            >
              #{{ campagne.id_campagne }}: {{ campagne.titre || 'Sans titre' }}
              <span class="ml-2 text-sm">
                ({{ campagne.nb_produits }} produit{{ campagne.nb_produits > 1 ? 's' : '' }})
              </span>
            </button>
          </li>
        </ul>

        <!-- Détails de la campagne sélectionnée -->
        <div v-if="selectedCampagneId" class="bg-gray-50 rounded-lg p-4">
          <div 
            v-for="campagne in campagnes" 
            :key="campagne.id_campagne"
            v-show="selectedCampagneId === campagne.id_campagne"
          >
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <p class="text-sm text-gray-600">Date de début</p>
                <p class="font-semibold">{{ formatDate(campagne.debut) }}</p>
              </div>
              <div>
                <p class="text-sm text-gray-600">Date de fin</p>
                <p class="font-semibold">{{ formatDate(campagne.fin) }}</p>
              </div>
              <div>
                <p class="text-sm text-gray-600">Nombre de produits</p>
                <p class="font-semibold">{{ campagne.nb_produits }}</p>
              </div>
              <div>
                <p class="text-sm text-gray-600">Réduction</p>
                <p class="font-semibold">
                  <span v-if="campagne.valeur_min && campagne.valeur_max">
                    {{ campagne.valeur_min }}% - {{ campagne.valeur_max }}%
                  </span>
                  <span v-else-if="campagne.valeur_min">
                    {{ campagne.valeur_min }}%
                  </span>
                  <span v-else>N/A</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Message si aucune campagne -->
      <div v-else-if="!isLoading" class="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div class="flex items-center gap-3">
          <i class="fas fa-info-circle text-blue-600"></i>
          <p class="text-blue-800">Aucune campagne programmée</p>
        </div>
      </div>

      <!-- Loading state -->
      <div v-if="isLoading" class="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
        <div class="flex items-center justify-center gap-3">
          <i class="fas fa-spinner fa-spin text-blue-600"></i>
          <p class="text-gray-700">Chargement des campagnes...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, computed } from 'vue'
import { PageHeader } from '@/components'
import { getCampagnesByVendeur } from '@/api/campagnes'
import { useAuthStore } from '@/stores/auth'
import type { PromotionFilter, PromotionData, Campagne } from '@/types'
import {useRouter} from "vue-router";
import { getVendeurMarques } from '@/api/brands'
import { getCategoriesTree } from '@/api/categories'
import type { CategorieNode } from '@/types/categorie'
import { getProductsPage } from '@/api/produits'

// État réactif
const isLoading = ref(false)
const campagnes = ref<Campagne[]>([])
const selectedCampagneId = ref<number | null>(null)
const authStore = useAuthStore()
const router = useRouter()

const filters = reactive<PromotionFilter>({
  reference: '',
  brand: '',
  soldBy: '',
  productsPerPage: '',
  displayBy: '',
  sortBy: '',
  category: '',
  subCategory: '',
  subSubCategory: '',
  creationPeriodStart: '',
  creationPeriodEnd: '',
  shootingId: ''
})

const promotionData = ref<PromotionData[]>([])

// ---- Dynamic filter options (DB-backed) ----
const brandOptions = ref<Array<{ id: string; number: number; name: string; isDefault: boolean }>>([])
const categoriesTree = ref<CategorieNode[]>([])
const soldByOptions = ref<string[]>([])

const level1Categories = computed(() => categoriesTree.value)
const level2Categories = computed(() => {
  const id = Number(filters.category) || null
  if (!id) return []
  const found = categoriesTree.value.find(c => c.id_categorie === id)
  return found?.children ?? []
})
const level3Categories = computed(() => {
  const id1 = Number(filters.category) || null
  const id2 = Number(filters.subCategory) || null
  if (!id1 || !id2) return []
  const level1 = categoriesTree.value.find(c => c.id_categorie === id1)
  const level2 = level1?.children?.find(c => c.id_categorie === id2)
  return level2?.children ?? []
})

// Charger les campagnes du vendeur
const loadCampagnes = async () => {
  try {
    isLoading.value = true
    if (authStore.user?.id_vendeur) {
      const result = await getCampagnesByVendeur(authStore.user.id_vendeur)
      campagnes.value = result
      
      // Sélectionner la première campagne par défaut
      if (result.length > 0 && !selectedCampagneId.value) {
        selectedCampagneId.value = result[0].id_campagne
      }
    }
  } catch (error) {
    // Erreur silencieuse
  } finally {
    isLoading.value = false
  }
}

// Fonction pour appliquer les filtres
const applyFilters = async () => {
  try {
    isLoading.value = true
    // Simulation d'un appel API
    await new Promise(resolve => setTimeout(resolve, 1000))
    // TODO: Implémenter la récupération des produits de la campagne sélectionnée
  } catch (error) {
    // Erreur silencieuse
  } finally {
    isLoading.value = false
  }
}

// Fonction pour exporter en Excel
const exportToExcel = async () => {
  try {
    // Simulation d'un export Excel
    await new Promise(resolve => setTimeout(resolve, 2000))

    alert('Export Excel terminé!')
  } catch (error) {
    alert('Erreur lors de l\'export Excel.')
  }
}

// Formater une date pour l'affichage
const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return ''
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('fr-FR')
}

// Lifecycle
onMounted(async () => {
  if (!authStore.isInitialized) {
    await authStore.checkAuth()
  }

  if (!authStore.isAuthenticated) {
    router.push({ name: 'auth' })
    return
  }
  // Load campaigns and dynamic filter options in parallel
  await Promise.all([
    loadCampagnes(),
    (async () => {
      try {
        // Brands
        brandOptions.value = await getVendeurMarques()
      } catch (e) {
        console.warn('Unable to load brands', e)
        brandOptions.value = []
      }
      try {
        // Categories tree
        categoriesTree.value = await getCategoriesTree('fr')
      } catch (e) {
        console.warn('Unable to load categories tree', e)
        categoriesTree.value = []
      }
      try {
        // SoldBy options: derive distinct vendu_par values from products list (light page)
        const id_vendeur = authStore.user?.id_vendeur
        if (id_vendeur) {
          const page = await getProductsPage({ id_vendeur, take: 200, skip: 0, orderBy: 'id_produit', orderDir: 'DESC' })
          const distinct = Array.from(
            new Set(
              (page.items || [])
                .map((p: any) => p?.vendu_par ?? '')
                .filter((v: any) => typeof v === 'string' && v.length > 0)
            ),
          ) as string[]
          soldByOptions.value = distinct
        } else {
          soldByOptions.value = []
        }
      } catch (e) {
        console.warn('Unable to load soldBy options', e)
        soldByOptions.value = []
      }
    })(),
  ])
})
</script>

<style scoped>
/* Styles spécifiques si nécessaire */
</style>
